import { classNames } from '@vkontakte/vkjs';
import { useVKUIPlatform } from '@dui/hooks';
import styles from './TypingIcon.module.css';

interface TypingIconProps {
  className?: string;
}

export function TypingIcon(props: TypingIconProps) {
  const { className } = props;
  const platform = useVKUIPlatform();

  return (
    <div className={classNames(styles.root, styles[`root__${platform}`], className)} role="presentation">
      <div className={styles.in}>
        <div className={styles.dot} />
        <div className={classNames(styles.dot, styles.dotFirst)} />
        <div className={classNames(styles.dot, styles.dotSecond)} />
      </div>
    </div>
  );
}
